import isMobile from "ismobilejs";
import { detect } from "detect-browser";

const NAMESPACE = "[device]";

// function updateData() {
//   let userAgent = navigator.userAgent;
//
//   let result = isMobile();
//
//   console.log('phone:', result.phone);
//   console.log('tablet:', result.tablet);
//   console.log('ios:', result.apple.device);
//   console.log('android:', result.android.device);
//
//   let browser = detect();
//   result.browser = browser;
//
//   return result;
// }
//
// window.isMobile = isMobile;

// updateData();

let isMobileData = isMobile();
let mobileLayout = isMobileData.phone || window.innerWidth < 700;

let browser = detect();
// console.log(browser);
console.log("isMobileData");
console.log(isMobileData);

let debugText = "";
debugText += "isMobileData.phone:" + isMobileData.phone;
debugText += "\nisMobileData.apple:" + isMobileData.apple;
// debugText += '\nbrowser.name:'+browser.name;
// document.querySelector("#debugLog").innerText = debugText;

// initial state
const state = {
  breakpoints: {
    desktopMedium: 1440,
    desktopSmall: 1280,
    tablet: 1024,
    mobile: 500,
    heightMedium: 800,
    heightShort: 600,
  },

  minContentHeight: 400,

  mobileLayout: mobileLayout,

  tablet: isMobileData.tablet,
  mobile: isMobileData.phone,
  ios: isMobileData.apple.device,
  android: isMobileData.android.device,
  //
  // browser: {
  //   name: browser.name,
  //   version: browser.version,
  //   os: browser.os
  // },
};

// getters
const getters = {};

// actions
const actions = {
  updateMobileState({ state, commit, dispatch }, value) {
    let isMobileData = isMobile();
    // let browser = detect();

    console.log("ios?:", isMobileData.apple.device);
    // let browserVersion = browser.version.split('.');

    if (isMobileData.phone || isMobileData.tablet) {
      document.body.classList.remove("desktop");
      document.body.classList.add("touch");

      // if( isMobileData.apple.device && browserVersion[0] < 13 ) {
      //   document.body.classList.add('ios-under-12');
      // }
    } else {
      document.body.classList.remove("touch");
      document.body.classList.remove("ios-under-12");
      document.body.classList.add("desktop");
    }

    let updatedState = {
      mobileLayout:
        isMobileData.phone && window.innerWidth < state.breakpoints.mobile,

      tablet: isMobileData.tablet,
      mobile: isMobileData.phone,
      ios: isMobileData.apple.device,
      android: isMobileData.android.device,
      // browser: {
      //   name: browser.name,
      //   version: browser.version,
      //   os: browser.os
      // }
    };

    commit("updateMobileState", { updatedState });
  },
};

// mutations
const mutations = {
  updateMobileState(state, payload) {
    // console.log('mutation updateMobileState');
    //
    // console.log(payload);

    state.mobileLayout = payload.updatedState.mobileLayout;
    state.tablet = payload.updatedState.tablet;
    state.mobile = payload.updatedState.mobile;
    state.ios = payload.updatedState.ios;
    state.android = payload.updatedState.android;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
